<form [formGroup]="referenceInfoForm">
  <section class="container">
    <div class="info top-bottom" i18n="@@ReferenceInfoComponentTitle">
      Reference info
    </div>
    <section class="reference-info">
      <section class="section">
        <div class="input-field">
          <label i18n="@@ReferenceInfoAssigneeLabel">Assignee</label>
          <mat-form-field appearance="outline" class="form-field">
            <mat-select
              formControlName="assignee"
              disableOptionCentering
              panelClass="assignee-select-panel"
            >
              <mat-option [value]="'unassigned'" class="assignee-option"
                >Unassigned</mat-option
              >
              @for (assignee of assignees; track assignee) {
              <mat-option class="assignee-option" [value]="assignee">
                {{ assignee }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-field">
          <label i18n="@@ReferenceInfoPoNumberLabel"
            >PO Number (Optional)</label
          >
          <mat-form-field class="form-field" appearance="outline">
            <input
              matInput
              formControlName="poNumber"
              maxlength="100"
              placeholder="Enter PO Number"
              i18n-placeholder="@@ReferenceInfoPoNumberPlaceholder"
              (blur)="sanitizeFields('poNumber')"
            />
          </mat-form-field>
        </div>
      </section>
      <section class="section">
        <div class="input-field-container">
          <label i18n="@@ReferenceInfoRefLabel">Reference (Optional)</label>
          <mat-form-field class="form-field" appearance="outline">
            <input
              matInput
              formControlName="reference"
              maxlength="100"
              placeholder="Enter Reference"
              i18n-placeholder="@@ReferenceInfoReferencePlaceholder"
              (blur)="sanitizeFields('reference')"
            />
          </mat-form-field>
        </div>
        <div class="input-field-container">
          <label i18n="@@ReferenceInfoSubClientRefLabel"
            >Sub Client Reference (Optional)</label
          >
          <mat-form-field class="form-field" appearance="outline">
            <input
              matInput
              formControlName="subClientReference"
              maxlength="100"
              placeholder="Enter Sub Client Reference"
              i18n-placeholder="@@ReferenceInfoSubClientReferencePlaceholder"
              (blur)="sanitizeFields('subClientReference')"
            />
          </mat-form-field>
        </div>
      </section>
      <section>
        <label i18n="@@ReferenceInfoFreeTextLabel">Free Text (Optional)</label>
        <mat-form-field appearance="outline" class="input-field">
          <textarea
            rows="3"
            matInput
            formControlName="freeText"
            maxlength="{{ textAreaMaxlength }}"
            #freeTextInput
            placeholder="Enter a free text…"
            i18n-placeholder="@@ReferenceInfoFreeTextPlaceholder"
            (blur)="sanitizeFields('freeText')"
          ></textarea>
        </mat-form-field>
        <mat-hint class="remaining-characters free-text-count-hint">
          {{ remainingCharacters(freeTextInput.value) }}/{{ textAreaMaxlength }}
          <ng-container i18n="@@ReferenceInfoFreeTextHint">
            characters</ng-container
          >
        </mat-hint>
      </section>
      <section>
        <label i18n="@@ReferenceAdditionalInsLabel"
          >Additional Instructions (Optional)</label
        >
        <mat-form-field appearance="outline" class="input-field">
          <textarea
            rows="3"
            matInput
            formControlName="additionalInstruction"
            maxlength="{{ textAreaMaxlength }}"
            #additionalInsInput
            placeholder="Enter any additional instructions…"
            i18n-placeholder="@@ReferenceInfoAdditionalInstructionPlaceholder"
            (blur)="sanitizeFields('additionalInstruction')"
          ></textarea>
        </mat-form-field>
        <mat-hint class="remaining-characters">
          {{ remainingCharacters(additionalInsInput.value) }}/{{
            textAreaMaxlength
          }}
          <ng-container i18n="@@ReferenceAdditionalInsHint">
            characters</ng-container
          >
        </mat-hint>
      </section>
    </section>
  </section>
</form>
